import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  BETS_TOTAL_ODDS_HEIGHT,
  BOTTOM_NAVIGATION_ELEMENT_DEFAULT_HEIGHT,
  EDIT_BET_ELEMENT_SWITCHER_HEIGHT,
  QUICK_BET_ELEMENT_DEFAULT_HEIGHT
} from 'utils/constants/app/BottomNavigationDefaultData';
import { BETSLIP_AREA_ID } from 'newelements/_Betslip/utils/constants/shared';
import {
  getBetsTotalOdds,
  getEditBet,
  getQuickBetEnabled,
  getQuickBetStake
} from 'store/selectors/betslip';

export const useCalculateBetslipFixedSwitchersHeight = (): number => {
  const isQuickBetEnabled = useSelector(getQuickBetEnabled);
  const { active: isEditBetActive } = useSelector(getEditBet) || {};
  const quickBetStake = useSelector(getQuickBetStake);
  const betsTotalOdds = useSelector(getBetsTotalOdds);

  return useMemo(() => {
    let height = BOTTOM_NAVIGATION_ELEMENT_DEFAULT_HEIGHT;
    const betslipTotalOdds = document.getElementById('betslipTotalOdds');
    const betslipArea = document.getElementById(BETSLIP_AREA_ID);

    if (isQuickBetEnabled && quickBetStake) {
      height += betslipArea?.clientHeight || QUICK_BET_ELEMENT_DEFAULT_HEIGHT;
    }

    if (isEditBetActive) {
      height += betslipArea?.clientHeight || EDIT_BET_ELEMENT_SWITCHER_HEIGHT;
    }

    if (betsTotalOdds) {
      height += betslipTotalOdds?.clientHeight || BETS_TOTAL_ODDS_HEIGHT;
    }

    return height;
  }, [isQuickBetEnabled, isEditBetActive, quickBetStake, betsTotalOdds]);
};
